export default function HeightInput({ setHeight }) {
  const handleHeightChange = (e) => {
    const val = e.target.value
    setHeight(val * 30.48)
  }

  return (
    <div className="input-group mb-3">
      <span className="input-group-text" >Height (ft)</span>
      <input type="number" min={0} className="form-control" placeholder={6.33} onChange={handleHeightChange} />
    </div>
  )
}
